import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Typography, TableCell, Chip, Hidden, ListItem, LinearProgress, CircularProgress} from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { fetchDocToSign, getUrlSign } from 'src/core/redux/action/transactionsAction'
import { withToast } from 'src/shared/Toast'
import { withRouter, RouteComponentProps } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast } from 'src/shared/Toast/Toast'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import { Datatable, DatatableToolbar, DatatableHead, DatatableBody } from 'src/shared/Datatable'
import { TableSortCell } from 'src/shared/TableSort'
import { ISignature } from 'src/type/signature'
import DatatableRow from 'src/shared/Datatable/DatatableRow'
import Btn from 'src/shared/Btn/Btn'
import { mapValuesContractual } from 'src/shared/utils/helpers'
import { SignatureCriteria } from 'src/type/criteria/signatureCriteria'
import {submit, isInvalid} from 'redux-form'
import PcDialog from 'src/shared/Dialog/PcDialog'
import InformationContractualForm from 'src/page/Consumer/Enterprise/forms/InformationContractualForm'
import BtnActions from 'src/shared/Btn/BtnActions'
import { fetchEnterprise, updateEnterprise } from 'src/core/redux/action/enterpriseInfosAction'
import Alert from 'src/shared/Alert/Alert'

const styles = (t: Theme) => createStyles({
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    listLine: {
        paddingTop: t.spacing.unit * 3,
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        wordBreak: 'break-word',
    },
    listTitle: {
        fontWeight: 'bold'
    },
    listText: {
        marginBottom: '.75rem',
        width: '100%'
    },
    listCategories: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 0,
        wordBreak: 'break-all'
    },
    listAction: {
        display: 'flex',
        justifyContent: 'center',
        borderBottom: `1px solid ${t.palette.divider}`
    },
    odd: {
        background: 'rgba(237, 28, 36, .1)'
    }
});

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  WithStyles<typeof styles>,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>{
    contractNumber: string;
}

const paginateName = 'docToSign';
const paginateAction = fetchDocToSign;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IState {
    modal: boolean;
    modalType: string | undefined;
    documentIdSelected: string;
}

class DocumentToSign extends React.Component<IProps, IState> {
  state = {
    modal: false,
    modalType: undefined,
    documentIdSelected: "",
  }

  render(){
    const { t, docToSign, connectedUser, formatDate, mapName, classes, enterprise } = this.props
    const { modalType } = this.state
    const canSign = () => connectedUser && !!connectedUser.phone

    return(
        <>
            {docToSign &&
                <>
                    {/* 
                    <Typography variant="body2">
                        {t.document_to_sign_first_label_first}
                        <span style={{fontSize: '1.1rem', fontWeight: 'bold', margin: '0 5px'}}>{docToSignSize}</span>
                        {docToSign && docToSign.length > 1 ? t.document_to_sign_first_label_last_plural : t.document_to_sign_first_label_last_singular}
                    </Typography>
                    <br />
                    */}
                    {canSign() &&
                        <Typography variant="body2">
                            {t.document_to_sign_second_label}:
                            <span style={{fontSize: '1.1rem', fontWeight: 'bold', marginLeft: '5px'}}>{connectedUser.phone}</span>
                        </Typography>
                    }
                    {!canSign() &&
                        <Alert type="error">{t.document_to_sign_warning_phone}</Alert>
                    }
                    <br />
                    <Alert type="info">
                        {t.document_to_sign_third_label_first}
                        <span style={{fontSize: '1.1rem', fontWeight: 'bold'}}>{t.EnterpriseDetail_tab_signature}</span>.
                        <span style={{marginLeft: '3px'}}>{t.document_to_sign_third_label_second}</span>
                        <span style={{fontSize: '1.1rem', fontWeight: 'bold'}}>{t.document_signed}</span>
                    </Alert>
                    <br />
                    <Hidden xsDown implementation="css">
                        <Datatable
                            name={paginateName}
                            action={paginateAction}
                            isExpendRow={true}
                            >
                            <DatatableToolbar search="global_search"/>
                            <DatatableHead>
                                <TableSortCell name="sent_at">{t.signature_date_send}</TableSortCell>
                                <TableSortCell name="name">{t.signature_document}</TableSortCell>
                                {/* <TableSortCell name="expire_at">{t.signature_date_expire}</TableSortCell> */}
                                <TableCell>{t.categories}</TableCell>
                                <TableCell>{t.actions}</TableCell>
                            </DatatableHead>
                            <DatatableBody renderRow={this.renderRow}/>
                        </Datatable>
                    </Hidden>
                    <Hidden smUp implementation="css">
                        {docToSign.map((d, index) => {
                            return (
                                <div key={`wpr-${d.id}`} className={index % 2 === 0 ? classes.odd : ''}>
                                    <ListItem className={classes.listLine} key={`line-${d.id}`}>
                                        <Typography variant="body2" className={classes.listTitle} gutterBottom>{t.signature_date_send}</Typography>
                                        <Typography variant="body2" className={classes.listText} gutterBottom>{formatDate(new Date(d.sent_at))}</Typography>

                                        <Typography variant="body2" className={classes.listTitle} gutterBottom>{t.signature_document}</Typography>
                                        <Typography variant="body2" className={classes.listText} gutterBottom>{d.name}</Typography>

                                        {/*
                                        <Typography variant="body2" className={classes.listTitle} gutterBottom>{t.signature_date_expire}</Typography>
                                        <Typography variant="body2" className={classes.listText} gutterBottom>{d.expire_at ? formatDate(d.expire_at) : '-'}</Typography>
                                        */}

                                        <Typography variant="body2" className={classes.listTitle} gutterBottom>{t.description}</Typography>
                                        <Typography variant="body2" className={classes.listText} gutterBottom>{d.description}</Typography>

                                        <Typography variant="body2" className={classes.listTitle} gutterBottom>{t.categories}</Typography>
                                        <div className={classes.listCategories}>
                                            {d.category_document && d.category_document.length > 0 &&
                                                d.category_document.split(",").map(c =>
                                                    mapName.get(c) !== undefined ? <Chip key={`${d.id}-category-document-${c}`} label={mapName.get(c)} className={classes.chip}/> : ''
                                                )
                                            }
                                        </div>
                                    </ListItem>
                                    <ListItem className={classes.listAction} key={`actions-${d.id}`}>
                                        <Btn
                                            color='primary'
                                            onClick={this.verificationSign(d)}
                                            icon='edit'
                                            disabled={!canSign()}
                                            variant='contained'
                                        >
                                            {t.sign}
                                        </Btn>
                                    </ListItem>
                                </div>
                            )
                        })}
                    </Hidden>
                </>
            }
            <PcDialog
                open={this.state.modal}
                {...modalType === "EDIT_CONTRACTUAL" &&  {title: t.EnterpriseDetail_info_contractual_title_edit}}
                maxWidth="md"
                fullWidth={true}
                {...modalType === "EDIT_CONTRACTUAL" &&  {actions: (
                    <BtnActions
                        cancelHandler={() => this.toggleModal(false)}
                        confirmHandler={this.submitFormRemotely}
                        disableNext={this.props.isInfoContractualFormValid}
                        confirmLabel={t.save}
                    />)
                }}
            >
                {modalType === "EDIT_CONTRACTUAL" &&
                    <>
                        <Alert type="warning">{t.EnterpriseDetail_info_contractual_modal_confirm}</Alert>
                        {enterprise.person_to_notify_email &&
                            <InformationContractualForm
                                onSubmit={this.handleSubmitForm} 
                                initialValues={{
                                person_to_notify_first_name: enterprise.person_to_notify_first_name,
                                person_to_notify_last_name: enterprise.person_to_notify_last_name,
                                person_to_notify_email: enterprise.person_to_notify_email,
                                person_to_notify_address: enterprise.person_to_notify_address,
                                emir_status: enterprise.emir_status,
                                lei: enterprise.lei,
                                rcs_city_legal_representative: enterprise.rcs_city_legal_representative,
                                siren_legal_representative: enterprise.siren_legal_representative,
                                }}
                            />
                        }
                        {!enterprise.person_to_notify_email &&
                            <InformationContractualForm 
                                onSubmit={this.handleSubmitForm} 
                            />
                        }
                    </>
                }
                {modalType === "PREPARE_TUNNEL" && 
                    <>
                        <Typography variant="title" align="center">{t.signature_tunnel_prepare_waiting}</Typography><br/>
                        <LinearProgress />
                    </>
                }
                {!modalType && <CircularProgress size={32}/>}
            </PcDialog>
        </>
    )
  }

  @autobind
  private renderRow(s: ISignature) {
    const {formatDate, t, connectedUser} = this.props
    const canSign = () => connectedUser && !!connectedUser.phone
    return (
      <DatatableRow expendedChild={this.renderExpendedRow(s)}>
        <TableCell style={{maxWidth: 80, whiteSpace: 'normal'}}>{formatDate(s.created_at)}</TableCell>
        <TableCell style={{maxWidth: '30%', whiteSpace: 'normal', wordBreak: 'break-all'}}>{s.name}</TableCell>
        {/* <TableCell style={{maxWidth: 80,  whiteSpace: 'normal'}}>{s.expire_at ? formatDate(s.expire_at) : '-'}</TableCell> */}
        <TableCell style={{maxWidth: '20%', whiteSpace: 'normal', wordBreak: 'break-all'}}>{this.renderCategoriesCol(s)}</TableCell>
        <TableCell>
            <Btn
                color='primary'
                onClick={this.verificationSign(s)}
                icon='edit'
                variant='contained'
                disabled={!canSign()}
            >
                {t.sign}
            </Btn>
        </TableCell>
      </DatatableRow>
    )
  }

  private renderCategoriesCol(s: ISignature){
    const {mapName, classes} = this.props
    return (
        <>
            {s.category_document && s.category_document.length > 0 &&
                s.category_document.split(",").map(c =>
                    mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-document-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                )
            }
            {s.category_produit && s.category_produit.length > 0 &&
                s.category_produit.split(",").map(c =>
                    mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-produit-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                )
            }
            {s.category_principale && s.category_principale.length > 0 &&
                s.category_principale.split(",").map(c =>
                    mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-principale-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                )
            }
            {s.category_type && s.category_type.length > 0 &&
                s.category_type.split(",").map(c =>
                    mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-type-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                )
            }
        </>
    )

  }
  componentDidMount(){
    this.props.updateCriteriaByObject({sort_by: "created_at", order_by: "desc", target_type: "TRANSACTION", target_id: this.props.contractNumber})
   } 

  private renderExpendedRow(s: ISignature): React.ReactChild {
    const {t} = this.props
    return (
        <Typography variant="inherit" gutterBottom>
            <span style={{fontWeight: 'bold'}}>{t.description} </span> : 
            <span style={{marginLeft: '3px'}}>{s.description ? s.description : '-'}</span>
        </Typography>
    )
  }

  @autobind
  private submitFormRemotely() {
      this.props.submitForm(submit("informationContractualForm"));
  };

  @autobind
  private handleSubmitForm(values){
    const {updateEnterpriseInfo, promisesWithProgress, toastError, enterprise, toastSuccess, t} = this.props
    promisesWithProgress(
      updateEnterpriseInfo(enterprise.id, mapValuesContractual(values)).then(res => {
        toastSuccess(t.EnterpriseDetail_info_contractual_edit_sucess)
        this.setState({modalType: "PREPARE_TUNNEL"}, () => {
            setTimeout(() => {
              this.handleSign(this.state.documentIdSelected)
            }, 300)
          })
      }).catch(err => {
          toastError(err.msg)
      })
    )
  }

  @autobind
  private toggleModal(action){
      this.setState({modal: action})
  }

  @autobind
  private toggleModalType(type, callback?){
    if(callback){
      this.setState({modalType: type}, () => callback)
    } else {
      this.setState({modalType: type})
    }
  }

  verificationSign = document => e => {
    const {enterprise, fetchEnterprise} = this.props
    fetchEnterprise(enterprise.id).then(res => {
      if(res.can_edit_contractual_data === true && 
          (document.category_document && document.category_document.indexOf("document-cadre") > -1 && document.must_be_signed === true)){
          this.setState({documentIdSelected: document.document_id})
          this.toggleModalType("EDIT_CONTRACTUAL", this.toggleModal(true))
      } else {
          this.toggleModalType("PREPARE_TUNNEL", this.toggleModal(true))
          this.handleSign(document.document_id)
      }
    })
  }

  @autobind
  private handleSign(id: string){
    const {getLinkToSign, enterprise, promisesWithProgress, toastError} = this.props
    promisesWithProgress(
        getLinkToSign(enterprise.id, id).then(res => {
            this.toggleModal(false)
            window.location.href = res
        }).catch(err => {
            this.toggleModal(false)
            toastError(err.msg)
        })
    )
  }

}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
    enterprise: state.accountInfo.enterpriseSelected,
    criteria: state.paginate.docToSign.criteria,
    docToSign: state.paginate.docToSign.entities,
    docToSignSize: state.paginate.docToSign.total_size,
    categories: state.categories.entities,
    mapName: state.utils.mapCategories,
    isInfoContractualFormValid: isInvalid("informationContractualForm")(state),
});

const dispatch2props = dispatch => ({
    fetch: (c: SignatureCriteria) => dispatch(fetchDocToSign(c)),
    fetchEnterprise: (id: string) => dispatch(fetchEnterprise(id)),
    submitForm: (handerSubmit) => dispatch(handerSubmit),
    updateEnterpriseInfo: (id: string, data: any) => dispatch(updateEnterprise(id, data)),
    updateCriteriaByObject: (object: any) => dispatch(actions.updateCriteriaByObject(object)),
    getLinkToSign:(enterpriseId: string, docId: string) => dispatch(getUrlSign(enterpriseId, docId))
});

export default compose(
  withGlobalProgress,
  withRouter,
  withToast,
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(DocumentToSign)



// WEBPACK FOOTER //
// ./src/page/Consumer/Transactions/documents/tabs/DocumentToSign.tsx